import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";
import { interviewSchema } from "./schema";;
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCreateOpeningInterview } from "../create/mutation";
import { useUpdateOpeningInterview } from "../update/mutation";
import { fetchInterviewDataforForm } from "./read";

export const useInterviewForm = ({ interviewId, openingId }) => {
    const navigate = useNavigate();

    const createInterviewMutation = useCreateOpeningInterview();
    const updateInterviewMutation = useUpdateOpeningInterview();

    const form = useForm({
        resolver: zodResolver(interviewSchema),
        defaultValues: {
            status: "shortlisted",
            title: "",
            applicant: "",
            recording_url: "",
            client_feedback: "",
            internal_feedback: "",
            transcript: "",
            is_cleared: undefined,
            date_scheduled: "",
        },
    });

    const requiredFields = useMemo(
        () => getRequiredFields(interviewSchema),
        [interviewSchema],
    );

    async function handleCreate(context) {
        const values = context.values;
        const response = await createInterviewMutation.mutateAsync({
            values,
        });
        navigate(`/apps/openings/${openingId}/interviews`);
    }

    async function handleRead(id) {
        const response = await fetchInterviewDataforForm({ id });
        return {
            ...response,
        };
    }

    async function handleUpdate(id, context) {
        const values = context.dirtyValues;
        const response = await updateInterviewMutation.mutateAsync({
            interviewId: id,
            values,
        });
        navigate(-1);
    }

    async function handleClose() {
        const response = await updateInterviewMutation.mutateAsync({
            interviewId: interviewId,
            values: { status: "closed" },
        });
        return response;
    }

    return {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
        handleClose,
    };
};
